import React, { useEffect, useState } from 'react';
import { Header, Statistic, Message } from 'semantic-ui-react';
import { API, formatTokens, showError } from '../helpers';

/**
 * 今日消费统计组件
 */
const TodayStats = ({ refreshTrigger = 0 }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayStats = async () => {
      setLoading(true);
      try {
        const now = new Date();
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

        const startTimestamp = Math.floor(startOfDay.getTime() / 1000);
        const endTimestamp = Math.floor(endOfDay.getTime() / 1000);

        // 获取今日总消费、token 用量和消费最高模型（均由后端聚合，日志列表是分页的不能用）
        const statRes = await API.get(`/api/log/self/stat?type=2&start_timestamp=${startTimestamp}&end_timestamp=${endTimestamp}`);

        if (!statRes.data.success) {
          showError(statRes.data.message);
          setLoading(false);
          return;
        }

        const stat = statRes.data.data || {};
        const quota = stat.quota || 0;
        // 输入 tokens 包含 prompt_tokens + cached_tokens + cache_creation_tokens，后端已合并
        const totalPromptTokens = stat.prompt_tokens || 0;
        const totalCompletionTokens = stat.completion_tokens || 0;
        const quotaPerUnit = (() => {
          const v = parseFloat(localStorage.getItem('quota_per_unit'));
          return v > 0 ? v : 500000;
        })();

        setStats({
          totalCost: quota,
          totalCostCNY: (quota / quotaPerUnit).toFixed(2),
          topModel: stat.top_model || '无',
          totalTokens: totalPromptTokens + totalCompletionTokens,
          totalPromptTokens,
          totalCompletionTokens
        });
      } catch (error) {
        showError('获取今日统计失败');
      } finally {
        setLoading(false);
      }
    };

    fetchTodayStats();
  }, [refreshTrigger]);

  if (loading) {
    return null;
  }

  if (!stats || stats.totalCost === 0) {
    return (
      <div>
        <Header as='h4'>今日消费</Header>
        <Message info>
          今日暂无消费记录
        </Message>
      </div>
    );
  }

  return (
    <div>
      <Header as='h4'>今日消费</Header>
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: '0.9em', color: '#666', marginBottom: '8px' }}>消费金额</div>
          <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#333' }}>¥{stats.totalCostCNY}</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: '0.9em', color: '#666', marginBottom: '8px' }}>消费最高模型</div>
          <div style={{ fontSize: '1.2em', fontWeight: '500', color: '#333', wordBreak: 'break-word' }}>{stats.topModel}</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: '0.9em', color: '#666', marginBottom: '8px' }}>总 tokens</div>
          <div style={{ fontSize: '1.8em', fontWeight: 'bold', color: '#333' }}>{formatTokens(stats.totalTokens)}</div>
          <div style={{ fontSize: '0.8em', color: '#999', marginTop: '4px' }}>
            输入 {formatTokens(stats.totalPromptTokens)} / 输出 {formatTokens(stats.totalCompletionTokens)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayStats;
